import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Layout from './components/layout/Layout';
import LoginForm from './components/auth/LoginForm';
import PublicMenu from './pages/PublicMenu';
import PublicCustomMenu from './pages/PublicCustomMenu';
import PrintMenu from './pages/PrintMenu';
import CategoryProducts from './pages/CategoryProducts';
import Dashboard from './pages/Dashboard';
import Analytics from './pages/Analytics';
import Allergens from './pages/Allergens';
import Ingredients from './pages/Ingredients';
import Categories from './pages/Categories';
import Products from './pages/Products';
import BusinessInfo from './pages/BusinessInfo';
import CustomMenus from './pages/CustomMenus';
import QrCodeManager from './pages/QrCodeManager';
import PopupManager from './pages/PopupManager';
import PopupBuilder from './pages/PopupBuilder';
import Users from './pages/Users';
import RoomsManager from './pages/RoomsManager';
import TableOrder from './pages/TableOrder';
import KitchenView from './pages/KitchenView';
import Cassa from './pages/Cassa';
import TableEntry from './pages/TableEntry';
import StaffLayout from './components/layout/StaffLayout';

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          
          {/* Rotte pubbliche per il menu */}
          <Route element={<CartProvider />}>
            <Route path="/" element={<PublicMenu />} />
            <Route path="/menu" element={<Navigate to="/" replace />} />
            <Route path="/menu/category/:id" element={<CategoryProducts />} />
            <Route path="/menu/custom" element={<Navigate to="/" replace />} />
            <Route path="/menu/custom/:id" element={<PublicCustomMenu />} />
            {/* Ordine dal QR del tavolo: stesso menu pubblico con sessione tavolo */}
            <Route path="/tavolo/:uuid" element={<TableEntry />} />
          </Route>

          {/* Stampa menu — protetta, senza sidebar admin */}
          <Route path="/menu/stampa" element={<ProtectedRoute><PrintMenu /></ProtectedRoute>} />

          {/* Viste staff (cameriere / cuoco) — layout minimal senza sidebar */}
          <Route element={<ProtectedRoute><StaffLayout /></ProtectedRoute>}>
            <Route path="/ordina" element={<TableOrder />} />
            <Route path="/cucina" element={<KitchenView />} />
            <Route path="/cassa" element={<Cassa />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
          
          {/* Rotte protette della dashboard */}
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="allergens" element={<Allergens />} />
            <Route path="ingredients" element={<Ingredients />} />
            <Route path="categories" element={<Categories />} />
            <Route path="categories/:id/products" element={<CategoryProducts />} />
            <Route path="products" element={<Products />} />
            <Route path="business" element={<BusinessInfo />} />
            <Route path="custom-menus" element={<CustomMenus />} />
            <Route path="qr-manager" element={<QrCodeManager />} />
            <Route path="popups" element={<PopupManager />} />
            <Route path="popups/new" element={<PopupBuilder />} />
            <Route path="popups/:id" element={<PopupBuilder />} />
            <Route path="users" element={<Users />} />
            <Route path="rooms" element={<RoomsManager />} />
            <Route path="table-order" element={<TableOrder />} />
            <Route path="kitchen" element={<KitchenView />} />
            <Route path="cassa" element={<Cassa />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
